(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initialize = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    const dots = [...root.querySelectorAll('[data-hero-dot]')];
    const prevButton = root.querySelector('[data-hero-prev]');
    const nextButton = root.querySelector('[data-hero-next]');
    if (slides.length < 2) return;

    let current = 0;
    let timer = null;
    const autoplay = root.dataset.autoplay === 'true' && !reduceMotion;
    const speed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;

    const goTo = (index) => {
      const next = (index + slides.length) % slides.length;
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      slides[current].setAttribute('inert', '');
      slides[next].classList.add('is-active');
      slides[next].removeAttribute('aria-hidden');
      slides[next].removeAttribute('inert');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      if (dots[next]) {
        dots[next].classList.add('is-active');
        dots[next].setAttribute('aria-selected', 'true');
      }
      current = next;
    };

    const stop = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };

    const start = () => {
      if (!autoplay) return;
      stop();
      timer = setInterval(() => goTo(current + 1), speed);
    };

    prevButton?.addEventListener('click', () => {
      goTo(current - 1);
      start();
    });
    nextButton?.addEventListener('click', () => {
      goTo(current + 1);
      start();
    });
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goTo(index);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    let touchStartX = 0;
    root.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0].clientX;
      stop();
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      const delta = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 40) goTo(delta < 0 ? current + 1 : current - 1);
      start();
    }, { passive: true });

    document.addEventListener('shopify:block:select', (event) => {
      const index = slides.findIndex((slide) => slide.dataset.blockId === event.target.dataset.blockId);
      if (index === -1) return;
      stop();
      goTo(index);
    });
    document.addEventListener('shopify:block:deselect', start);

    start();
  };

  document.querySelectorAll('[data-dorimo-hero]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-dorimo-hero]')));
})();
